import { RetryInterceptor } from '@cue/http-utils';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { HeaderInterceptor } from '@cue-admin/http-runtime';
import { coreProviders } from '@cue-admin/app-data';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { provideDataStores } from '@cue-admin/app-data';
import { ConfigService } from '@cue-admin/config';
import { gridProviders } from '@cue-admin/grid';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { provideQuillConfig } from 'ngx-quill/config';
import { accountProviders, accountRoutes } from '@cue-admin/account-pages';
import { provideGoogleAnalytics } from '@cue/google-analytics';
import { CALENDAR_SYNC_API_BASE_URL } from '@cue/calendar-sync';
import { CONSTANTS } from '@cue-admin/constants';

import { layoutRoutes } from '@cue-admin/layout';
import { treelistProviders } from '@cue-admin/treelist';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json?cache=' + new Date().toISOString());
}

export function appConfig(service: ConfigService) {
  return {
    providers: [
      provideGoogleAnalytics({
        keyFactory: () => {
          const configService = inject(ConfigService);
          return configService.value!.googleAnalyticsEnabled && configService.value!.googleAnalyticsKey != null
            ? configService.value!.googleAnalyticsKey
            : undefined;
        },
      }),
      provideDataStores(),
      provideRouter(
        [
          ...layoutRoutes,
          ...accountRoutes,
          {
            path: '**',
            redirectTo: 'notFound',
          },
        ],
        withComponentInputBinding()
      ),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimationsAsync(),
      coreProviders,
      accountProviders,
      gridProviders,
      treelistProviders,
      provideQuillConfig({}),
      importProvidersFrom(
        NotificationModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          },
        })
      ),
      { provide: NZ_I18N, useValue: en_US },
      DatePipe,
      {
        provide: ConfigService,
        useValue: service,
      },
      {
        provide: CALENDAR_SYNC_API_BASE_URL,
        useValue: `${service.apiURL}${CONSTANTS.api.prefix}/calendarsync`,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HeaderInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: RetryInterceptor,
        multi: true,
      },
    ],
  };
}
